<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <div class="row">
      <div class="col-md-12">
        <pr-input-column
          label="Adéquation de l'investissement avec le profil du client"
          [derrors]="derrors"
          [isDefault]="false"
        >
          <textarea
            class="full-w"
            type="text"
            placeholder="Commencez à écrire ici"
            rows="10"
            formControlName="clientAdequation"
          ></textarea>
        </pr-input-column>
      </div>
    </div>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
@if (loading) {
  <pr-loader
    text="Nous générons votre souscription, merci de patienter."
  ></pr-loader>
}
